'use strict';
const React = require('react');

class CheckoutPaymentTemplateComponent extends React.Component {
    render() {
        return (
            <div />
        );
    }
}

function mapStateToProps(state, ownProps) {
    return null;
}

function mapDispatchToProps(dispatch) {
    return null;
}

module.exports = {
    CheckoutPaymentTemplateComponent,
    mapStateToProps,
    mapDispatchToProps
}